// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__editPartnerDialog--l5Fwp {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 300px;
}
.style__editPartnerDialog--l5Fwp > div {
  margin-bottom: 1rem;
}
.style__searchFilter--ejNw_ {
  display: flex;
  gap: 1rem;
  margin: 1rem 0.125rem;
}
.style__buttonGroup--kN2iy {
  display: flex;
  gap: 0.5rem;
}
.style__syncButtonContainer--kDZ2F {
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0.125rem;
}
.style__datePickerContainer--YAG3H > div > div, .style__datePickerContainer--YAG3H > div > div:hover {
  border-color: #7d8781 !important;
}
.style__datePickerContainer--YAG3H > div > div:focus-within, .style__datePickerContainer--YAG3H > div > div:hover:focus-within, .style__datePickerContainer--YAG3H > div > div:focus-visible, .style__datePickerContainer--YAG3H > div > div:hover:focus-visible {
  outline: none !important;
  border-color: #7d8781 !important;
  box-shadow: 0 0.25rem 0.5rem -0.125rem rgba(12, 13, 13, 0.1), 0 0 0.25rem -0.125rem rgba(12, 13, 13, 0.06) !important;
  box-shadow: 0 4px 8px -2px rgba(12, 13, 13, 0.1), 0px 0px 4px -2px rgba(12, 13, 13, 0.06) !important;
}
.style__partnerDetailsContainer--TLYxO {
  display: flex;
  justify-content: space-between;
}
.style__partnerDetailsHeader--AES3W {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.style__partnerDetailsBadges--hV9Jn {
  display: flex;
  gap: 0.5rem;
}
.style__partnerDataContainer--QNOKF {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.style__icon--C_dMV {
  color: #7d8287;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PartnerPage/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAIA;EAEI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;AAJJ;AADA;EAQM,mBAAA;AAJN;AAJA;EAaI,aAAA;EACA,SAAA;EACA,qBAAA;AANJ;AATA;EAmBI,aAAA;EACA,WAAA;AAPJ;AAbA;EAwBI,aAAA;EACA,yBAAA;EACA,qBAAA;AARJ;AAlBA;EAiCQ,gCAAA;AAXR;AAaQ;EAEE,wBAAA;EACA,gCAAA;EC7BR,qHAAA;EAKA,oGAAA;ADiBF;AA/BA;EA8CI,aAAA;EACA,8BAAA;AAZJ;AAnCA;EAmDI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAbJ;AAzCA;EA0DI,aAAA;EACA,WAAA;AAdJ;AA7CA;EA+DI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAfJ;AAnDA;EAsEI,cAAA;EACA,eAAA;AAhBJ","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n@import '@yaak/components/src/shadows';\n\n:local {\n  .editPartnerDialog {\n    display: flex;\n    flex-direction: column;\n    padding: @spacing-100;\n    min-width: 300px;\n\n    > div {\n      margin-bottom: @spacing-100;\n    }\n  }\n\n  .searchFilter {\n    display: flex;\n    gap: @spacing-100;\n    margin: @spacing-100 @spacing-15;\n  }\n\n  .buttonGroup {\n    display: flex;\n    gap: @spacing-50;\n  }\n\n  .syncButtonContainer {\n    display: flex;\n    justify-content: flex-end;\n    margin: @spacing-100 @spacing-15;\n  }\n\n  .datePickerContainer {\n    > div {\n      > div,\n      > div:hover {\n        border-color: @color-pewter-grey-050 !important;\n\n        &:focus-within,\n        &:focus-visible {\n          outline: none !important;\n          border-color: @color-pewter-grey-050 !important;\n          .sys-elevation-shadow-level2() !important;\n        }\n      }\n    }\n  }\n\n  .partnerDetailsContainer {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .partnerDetailsHeader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: @spacing-50;\n  }\n\n  .partnerDetailsBadges {\n    display: flex;\n    gap: @spacing-50;\n  }\n\n  .partnerDataContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .icon {\n    color: @color-asphalt-grey-050;\n    cursor: pointer;\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editPartnerDialog": `style__editPartnerDialog--l5Fwp`,
	"searchFilter": `style__searchFilter--ejNw_`,
	"buttonGroup": `style__buttonGroup--kN2iy`,
	"syncButtonContainer": `style__syncButtonContainer--kDZ2F`,
	"datePickerContainer": `style__datePickerContainer--YAG3H`,
	"partnerDetailsContainer": `style__partnerDetailsContainer--TLYxO`,
	"partnerDetailsHeader": `style__partnerDetailsHeader--AES3W`,
	"partnerDetailsBadges": `style__partnerDetailsBadges--hV9Jn`,
	"partnerDataContainer": `style__partnerDataContainer--QNOKF`,
	"icon": `style__icon--C_dMV`
};
export default ___CSS_LOADER_EXPORT___;
